import { useMutation, useQueryClient } from "@tanstack/react-query";
import i18n from "i18n";
import { AIConfig } from "@graylog/enterprise-api";
import UserNotification from "util/UserNotification";
import { AI_CONFIGURATION_QUERY_STRING } from "ai/hooks/useAIConfiguration";
const enableAI = () => AIConfig.enableAI();
const disableAI = () => AIConfig.disableAI();
const useAIConfigurationMutations = () => {
  const queryClient = useQueryClient();
  const { mutateAsync: enable } = useMutation({
    mutationFn: enableAI,
    onSuccess: () => {
      UserNotification.success(i18n.t("notifications.ai_configuration_updated", { ns: "enterprise_ai" }));
      queryClient.invalidateQueries({
        queryKey: [AI_CONFIGURATION_QUERY_STRING]
      });
    },
    onError: (error) => {
      UserNotification.error(
        i18n.t("notifications.ai_configuration_update_failed", { ns: "enterprise_ai", error: String(error) })
      );
    }
  });
  const { mutateAsync: disable } = useMutation({
    mutationFn: disableAI,
    onSuccess: () => {
      UserNotification.success(i18n.t("notifications.ai_configuration_updated", { ns: "enterprise_ai" }));
      queryClient.invalidateQueries({
        queryKey: [AI_CONFIGURATION_QUERY_STRING]
      });
    },
    onError: (error) => {
      UserNotification.error(
        i18n.t("notifications.ai_configuration_update_failed", { ns: "enterprise_ai", error: String(error) })
      );
    }
  });
  return {
    enable,
    disable
  };
};
export default useAIConfigurationMutations;
